import './_styles.scss';
import React from 'react';

import {
  IoMdCheckbox as Checked,
  IoMdSquareOutline as NotChecked
} from 'react-icons/io';

export default ({ name, value, caption, onSelect }) => {

  const Icon = (!value) ? NotChecked : Checked;

  return (
    <label htmlFor={name} className="Checkbox noselect">

      <input
        id={name}
        name={name}
        type="checkbox"
        checked={value}
        onChange={onSelect}
      />

      <Icon className='Icon'/>

      <span
        className='Label'
        dangerouslySetInnerHTML={{ __html: caption }}
      />

    </label>
  )
}
